import styles from "./spinner.module.scss";
import { Eclipse } from "react-svg-spinners";
const CustomSpinner = () => {
  return (
    <div className={`${styles["customSPinner"]}`}>
      <Eclipse height={40} width={40} color="#c6c6c6" />
    </div>
  );
};

export default CustomSpinner;
